// src/Components/Common/SidebarUserProfile.tsx
// User profile component displayed at bottom of sidebar

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { fetchUserProfile } from '../../slices/thunks';

// Default avatar
import avatar1 from '../../assets/images/users/avatar-1.jpg';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('component_sidebar_user_profile');

interface SidebarUserProfileProps {
  className?: string;
}

const SidebarUserProfile: React.FC<SidebarUserProfileProps> = ({ className }) => {
  const dispatch = useDispatch<any>();
  // Ghi lại trang đang đứng để truyền qua "/logout" -> Logout.tsx -> "/login", cho phép quay lại
  // đúng trang này sau khi đăng nhập lại (xem Logout.tsx)
  const location = useLocation();

  // Get profile from Redux store
  const reduxProfile = useSelector((state: any) => state.UserProfile?.profile);
  
  const [userName, setUserName] = useState('Admin');
  const [userRole, setUserRole] = useState('Administrator');
  const [userAvatar, setUserAvatar] = useState(avatar1);
  
  // Update local state when Redux profile changes (including avatar)
  useEffect(() => {
    if (reduxProfile) {
      if (reduxProfile.name) {
        setUserName(reduxProfile.name);
      }
      if (reduxProfile.roleName) {
        setUserRole(reduxProfile.roleName);
      }
      if (reduxProfile.avatar) {
        setUserAvatar(reduxProfile.avatar);
      }
    }
  }, [reduxProfile]);

      useEffect(() => {
    // Dispatch Redux action to fetch profile (only once on mount)
    if (!reduxProfile) {
      dispatch(fetchUserProfile());
    }
    
    // Fallback: Load from localStorage if Redux is empty
    const loadFromLocalStorage = () => {
            const authUser = localStorage.getItem('authUser');
              if (authUser) {
        try {
          const user = JSON.parse(authUser);
          
          if (user.username) {
            setUserName(user.username);
          } else if (user.data?.first_name) {
            setUserName(user.data.first_name);
          } else if (user.email) {
            setUserName(user.email.split('@')[0]);
          }

          if (user.role) {
            setUserRole(user.role);
          } else if (user.data?.role) {
            setUserRole(user.data.role);
          }

          if (user.avatar) {
            setUserAvatar(user.avatar);
          } else if (user.data?.avatar) {
            setUserAvatar(user.data.avatar);
          }
        } catch (parseError) {
          console.error('Error parsing authUser from localStorage:', parseError);
        }
      }
    };

    if (!reduxProfile) {
      loadFromLocalStorage();
    }
  }, [dispatch, reduxProfile]);

  return (
    <div className={`sidebar-user-profile ${className || ''}`}>
      <div className="d-flex align-items-center gap-2 p-3 border-top">
        {/* Avatar */}
        <div className="flex-shrink-0">
          <img
            src={userAvatar}
            alt={userName}
            className="rounded-circle avatar-sm"
            style={{ width: '40px', height: '40px', objectFit: 'cover' }}
          />
        </div>

        {/* User Info */}
        <div className="flex-grow-1 overflow-hidden">
          <h6 className="mb-0 text-truncate fs-14">{userName}</h6>
          <p className="text-muted mb-0 text-truncate fs-12">{userRole}</p>
        </div>

        {/* Settings Dropdown */}
        <UncontrolledDropdown className="flex-shrink-0">
          <DropdownToggle
            tag="button"
            className="btn btn-sm btn-ghost-secondary btn-icon rounded-circle"
            type="button"
          >
            <i className="ri-settings-3-line fs-16"></i>
          </DropdownToggle>
          <DropdownMenu end>
            {/* <DropdownItem header className="text-muted">
              <small>Cài đặt</small>
            </DropdownItem>
            <DropdownItem divider /> */}
            <DropdownItem tag={Link} to="/profile">
              <i className="ri-user-line align-middle me-2"></i>
              {st('ho_so_ca_nhan_text')}
            </DropdownItem>
            <DropdownItem tag={Link} to="/change-password">
              <i className="ri-lock-password-line align-middle me-2"></i>
              {st('doi_mat_khau_text')}
            </DropdownItem>
            {/* <DropdownItem tag={Link} to="/user-management">
              <i className="ri-shield-user-line align-middle me-2"></i>
              Quản lý người dùng
            </DropdownItem>
            <DropdownItem tag={Link} to="/system-configuration">
              <i className="ri-settings-4-line align-middle me-2"></i>
              Cấu hình hệ thống
            </DropdownItem> */}
            <DropdownItem divider />
            <DropdownItem tag={Link} to="/logout" state={{ from: location }} className="text-danger">
              <i className="ri-logout-box-line align-middle me-2"></i>
              {st('dang_xuat_text')}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    </div>
  );
};

export default SidebarUserProfile;